import React from "react";
import PanelNav from "../Components/Panel/PanelNav";
import Serverspage from "../Components/Panel/Serverspage";
import Layout from "./Layout";

export default function Servers() {
  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4 grid grid-cols-1 lg:grid-cols-6 xl:grid-cols-5 w-full my-6">
        <PanelNav />
        <Serverspage />
      </section>
    </Layout>
  );
}
